import { Pipe, PipeTransform } from '@angular/core';
import { Helper, ProductType } from '../utils';

@Pipe({
  name: 'publicUrl',
  standalone: true,
})
export class PublicUrlPipe implements PipeTransform {
  transform(publicUrl: string, productType?: ProductType, height?: number): any {
    if (!publicUrl || publicUrl === '') {
      if (productType) {
        return `./assets/other/product_image_placeholder_${productType}.svg`;
      }
      return './assets/other/product_image_placeholder_dry.svg';
    }

    return Helper.handleImageUrlQueryParams(publicUrl, { height: height || 400 });
  }
}
